// import React, { useState, useRef, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Button,
//   Alert,
//   LinearProgress,
// } from '@mui/material';
// import FileDownloadIcon from '@mui/icons-material/FileDownload';
// import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
// import axios from 'axios';
// const DownloadInNewTab = () => {
//   const { id } = useParams();
//   const [error, setError] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const intervalRef = useRef(null);
//   const [hasLoadedOnce, setHasLoadedOnce] = useState(false); // to track initial render

//   const simulateProgress = (durationInSeconds, callback) => {
//     setProgress(0);
//     let current = 0;
//     const increment = 100 / durationInSeconds;

//     intervalRef.current = setInterval(() => {
//       current += increment;
//       if (current >= 100) {
//         clearInterval(intervalRef.current);
//         setProgress(100);
//         setLoading(false);
//         callback(); // open file after progress
//       } else {
//         setProgress(current);
//       }
//     }, 1000);
//   };

//   const handleOpenInNewTab = async () => {
//     setError(null);
//     setLoading(true);
//     setProgress(0);

//     const requestPayload = {
//       RequestInfo: {
//         apiId: "Rainmaker",
//         action: "_create",
//         did: 1,
//         key: "",
//         msgId: "20170310130900|en_IN",
//         ts: 0,
//         ver: ".01",
//       },
//     };

//     try {
//       const url = `${Urls?.qrCodeURL?.bpaQRCode}?applicationId=${id}`;
//       const response = await axios.post(url, requestPayload);

//       const fileUrl = response?.data;

//       if (!fileUrl) {
//         throw new Error('File URL not found in API response');
//       }

//       const simulatedSeconds = Math.floor(Math.random() * 6) + 5; // 5–10s

//       simulateProgress(simulatedSeconds, () => {
//         window.open(fileUrl, '_blank');
//       });
//     } catch (err) {
//       clearInterval(intervalRef.current);
//       setLoading(false);
//       setProgress(0);
//       console.error('❌ API Error:', err);
//       setError(err?.message || 'Something went wrong while fetching the file.');
//     }
//   };

//   // 👇 Call once on first load
//   useEffect(() => {
//     if (!hasLoadedOnce) {
//       setHasLoadedOnce(true);
//       handleOpenInNewTab();
//     }
//     return () => clearInterval(intervalRef.current);
//   }, []);

//   return (
//     <Box sx={{ maxWidth: 500, p: 2 }}>
//       {error && (
//         <Alert severity="error" sx={{ mb: 2 }}>
//           {error}
//         </Alert>
//       )}

//       {!loading && (
//         <Button
//           variant="contained"
//           startIcon={<FileDownloadIcon />}
//           onClick={handleOpenInNewTab}
//         >
//           View PDF
//         </Button>
//       )}

//       {loading && (
//         <Box sx={{ mt: 2 }}>
//           <Typography variant="subtitle1" mb={1}>
//             Preparing your file... Please wait.
//           </Typography>
//           <LinearProgress
//             variant="determinate"
//             value={progress}
//             sx={{ height: 10, borderRadius: 5 }}
//           />
//           <Typography variant="body2" color="text.secondary" mt={1}>
//             {Math.round(progress)}%
//           </Typography>
//         </Box>
//       )}
//     </Box>
//   );
// };

// export default DownloadInNewTab;

import React, { useState, useEffect, useRef } from "react";
import { Box, Typography, Button, Alert, LinearProgress, Stack } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { useParams } from "react-router-dom";
import axios from "axios";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";

const DownloadDocuments = () => {
  const { id } = useParams();
  const [error, setError] = useState(null);
  const [urls, setUrls] = useState({
    selfCertificateUrl: null,
    selfDrawingUrl: null,
  });
  const [loading, setLoading] = useState({ certificate: false, drawing: false });
  const [progress, setProgress] = useState({ certificate: 0, drawing: 0 });
  const intervalRefs = useRef({ certificate: null, drawing: null });

  useEffect(() => {
    const fetchUrls = async () => {
      try {
        const res = await axios.post(`${Urls?.qrCodeURL?.SelfMap}?applicationId=${id}`, {
          RequestInfo: {
            apiId: "Rainmaker",
            action: "_create",
            did: 1,
            key: "",
            msgId: "20170310130900|en_IN",
            ts: 0,
            ver: ".01",
          },
        });

        setUrls({
          selfCertificateUrl: res?.data?.selfCertificateUrl || null,
          selfDrawingUrl: res?.data?.selfDrawingUrl || null,
        });
      } catch (err) {
        console.error("API Error:", err);
        setError("Failed to fetch document URLs.");
      }
    };

    fetchUrls();

    return () => {
      clearInterval(intervalRefs.current.certificate);
      clearInterval(intervalRefs.current.drawing);
    };
  }, [id]);

  const simulateProgress = (type, callback) => {
    let curr = 0;
    const increment = 100 / (Math.floor(Math.random() * 6) + 5);
    setLoading((prev) => ({ ...prev, [type]: true }));
    setProgress((prev) => ({ ...prev, [type]: 0 }));

    intervalRefs.current[type] = setInterval(() => {
      curr += increment;
      if (curr >= 100) {
        clearInterval(intervalRefs.current[type]);
        setProgress((prev) => ({ ...prev, [type]: 100 }));
        setLoading((prev) => ({ ...prev, [type]: false }));
        callback();
      } else {
        setProgress((prev) => ({ ...prev, [type]: curr }));
      }
    }, 1000);
  };

  const handleDownload = (type) => {
    const url = type === "certificate" ? urls.selfCertificateUrl : urls.selfDrawingUrl;
    if (!url) return;

    simulateProgress(type, () => {
      window.open(url, "_blank");
    });
  };

  return (
    <Box sx={{ maxWidth: 600, p: 3 }}>
      {error && <Alert severity="error">{error}</Alert>}

      <Stack spacing={4}>
        {/* Self Certificate */}
        <Box>
          {urls.selfCertificateUrl ? (
            !loading.certificate ? (
              <Button variant="contained" startIcon={<FileDownloadIcon />} fullWidth onClick={() => handleDownload("certificate")}>
                View Self Certificate
              </Button>
            ) : (
              <React.Fragment>
                <Typography variant="body2" mb={1}>
                  Preparing document...
                </Typography>
                <LinearProgress value={progress.certificate} variant="determinate" sx={{ height: 10, borderRadius: 5 }} />
                <Typography variant="body2" mt={1}>
                  {Math.round(progress.certificate)}%
                </Typography>
              </React.Fragment>
            )
          ) : (
            <Alert severity="info">Self Certificate not available yet.</Alert>
          )}
        </Box>

        {/* Self Drawing */}
        <Box>
          {urls.selfDrawingUrl ? (
            !loading.drawing ? (
              <Button variant="contained" startIcon={<FileDownloadIcon />} fullWidth onClick={() => handleDownload("drawing")}>
                View Drawing PDF
              </Button>
            ) : (
              <React.Fragment>
                <Typography variant="body2" mb={1}>
                  Preparing document...
                </Typography>
                <LinearProgress value={progress.drawing} variant="determinate" sx={{ height: 10, borderRadius: 5 }} />
                <Typography variant="body2" mt={1}>
                  {Math.round(progress.drawing)}%
                </Typography>
              </React.Fragment>
            )
          ) : (
            <Alert severity="info">Drawing PDF not available yet.</Alert>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default DownloadDocuments;
